import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const ActualiteContainer = styled.article`
  &:not(:last-of-type) {
    border-bottom: 5px solid
      ${(props) => props.theme.a_color_gradients.a_medium};
  }
`

const ActualiteTitle = styled.h3`
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    color: white;
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const ActualiteImage = styled.h3`
  &:hover ~ ${ActualiteTitle} {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    color: white;
  }
`

const StyledLink = styled(AniLink)`
  &::after {
    border-bottom: 1px solid ${(props) => props.theme.c_color_gradients.c_dark};
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const ActuText = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export {
  ActualiteContainer,
  ActualiteTitle,
  ActualiteImage,
  StyledLink,
  ActuText,
}
